import { UseMutationOptions, useMutation } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { ErrorResponse } from '../../../common/validations'
import {
  VerifyInvitedUserCodeInput,
  VerifyInvitedUserCodeResponse,
  verifyInvitedUserCodeResponseSchema,
} from '../../../common/validations/invitation'

import { post } from 'api/apiClient'

export const useAPIVerifyInvitedUserCode = (
  uuid: string,
  options?: UseMutationOptions<
    VerifyInvitedUserCodeResponse,
    ErrorResponse,
    VerifyInvitedUserCodeInput
  >
) =>
  useMutation({
    mutationFn: (data) =>
      post(
        API_ENDPOINTS.INVITATION_VERIFY_CODE.replace(':uuid', uuid),
        data,
        verifyInvitedUserCodeResponseSchema
      ),
    throwOnError: false,
    ...options,
  })
